export const raw = (string) => {
    const htmlCollection = new DOMParser().parseFromString(string, 'text/html').body.childNodes;
    const array = [].slice.call(htmlCollection);
    return array;
};
